import { render, staticRenderFns } from "./ClicJsonInterno.vue?vue&type=template&id=6e24284d&"
import script from "./ClicJsonInterno.vue?vue&type=script&lang=js&"
export * from "./ClicJsonInterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports